// extracted by mini-css-extract-plugin
export default {"container":"CircleBtn_container__7vUQ-","image":"CircleBtn_image__1frGh","btn":"CircleBtn_btn__xBN9q","txt":"CircleBtn_txt__0LV2g"};